<!------------------------------------------------------------------------------
 File: BaseIcon 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 17/10/2018
 Time: 16:12
------------------------------------------------------------------------------->
<template>
    <i
        :class="cls">
        <slot></slot>
        {{content}}</i>
</template>

<script>
    export default {
        name: 'BaseIcon',
        components: {},
        props: {
            content: {
                type: String,
                default: ''
            },
            cls: {
                type: String,
                default: 'material-icons'
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseIcon.vue